class FileModal {
  init(refModal) {
    this.refModal = refModal;
  }

  async uploadFiles(files, options) {
    return await this.refModal.current.uploadFiles(files, options);
  }
}

export const fileService = new FileModal();
